import { FC } from "react";
import { IOrder } from "../../../model/IOrder";
import { DetailPanel, DetailRow } from "./DetailPanel";

const OrderShipping: FC<{ order: IOrder }> = ({ order }) => (
  <DetailPanel title="Shipping Info">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-8">
      <div>
        <DetailRow label="Delivery Option" value={order.siType} />
        <DetailRow label="Name" value={order.siName} />
        <DetailRow label="Company" value={order.siCompany} />
        <DetailRow label="Liftgate" value={order.liftgate} />
      </div>

      <div>
        <DetailRow label="Primary Phone" value={order.siPhone} />
        <DetailRow label="Secondary Phone" value={order.siSecondaryPhone} />
        <DetailRow label="EMail" value={order.siEmail} />
        <DetailRow label="Fax" value={order.siFax} />
      </div>

      <div>
        <DetailRow label="Street Address" value={order.siStreet} />
        <DetailRow
          label="City, State, ZIP"
          value={[order.siCity, order.siState, order.siZip].filter(Boolean).join(', ')}
        />
        <DetailRow label="Country" value={order.siCountry} />
        <DetailRow label="Carrier" value={order.siCarrier} />
        <DetailRow label="Tracking Number" value={order.siTrackingNum} />
      </div>
    </div>
  </DetailPanel>
);

export default OrderShipping;
